import * as React from "react";
const SvgFiRrKeyboardBrightness = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M16 18H8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1m-3-9V4c0-.55-.45-1-1-1s-1 .45-1 1v5c0 .55.45 1 1 1s1-.45 1-1m-8 8c0-.55-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1h3c.55 0 1-.45 1-1m19 0c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1s.45 1 1 1h3c.55 0 1-.45 1-1m-5.29-5.29 3-3A.996.996 0 1 0 20.3 7.3l-3 3a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29zm-12 0a.996.996 0 0 0 0-1.41l-3-3A.996.996 0 1 0 2.3 8.71l3 3c.2.2.45.29.71.29s.51-.1.71-.29z"
    />
  </svg>
);
export default SvgFiRrKeyboardBrightness;
